import { styled } from "@mui/material/styles";
import { Link } from "react-router";

export const StretchedLink = styled(Link)({
  color: "inherit",
  textDecoration: "none",

  "&::after": {
    content: '""',
    position: "absolute",
    inset: 0,
  },
});
